
namespace Matrix.Rebalancer {

    @Serenity.Decorators.registerClass()
    export class TradeMacroStepDialog extends SiteEntityDialog<TradeMacroStepRow, any> {
        protected getFormKey() { return TradeMacroStepForm.formKey; }
        protected getIdProperty() { return TradeMacroStepRow.idProperty; }
        protected getLocalTextPrefix() { return TradeMacroStepRow.localTextPrefix; }
        protected getNameProperty() { return TradeMacroStepRow.nameProperty; }
        protected getService() { return TradeMacroStepService.baseUrl; }

        protected form = new TradeMacroStepForm(this.idPrefix);

    }
}